/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ImageSearchIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Image Search',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m35.634 33.866-5.168-5.168a8.02 8.02 0 1 0-1.768 1.768l5.168 5.168a1.25 1.25 0 0 0 1.768-1.768ZM18 24a6 6 0 1 1 6 6 6 6 0 0 1-6-6Zm-1.227-6.883-5.5-5.5a2 2 0 0 0-2.829-.001L2 18.058V4h28v12.045a10.01 10.01 0 0 1 2 2.01V3a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h13.202a9.946 9.946 0 0 1 2.571-8.883ZM22 10.051a2.7 2.7 0 1 0 2.7-2.7 2.7 2.7 0 0 0-2.7 2.7Z"
    />
  </svg>`;
};
